<script setup>
import dayjs from 'dayjs';
import { computed, onMounted } from 'vue';

const props = defineProps({
  compromisso: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['loaded']);

const statusLabel = computed(() => {
  const s = props.compromisso.data?.status;
  if (s === 'aprovado') return 'Aprovado';
  if (s === 'reprovado') return 'Reprovado';
  if (s === 'aguardando') return 'Aguardando resposta';
  return s;
});

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    :column="3"
    :label-style="{ width: '15%' }"
    bordered
  >
    <a-descriptions-item
      label="Status"
      :span="3"
    >
      {{ statusLabel }}
    </a-descriptions-item>
    <a-descriptions-item
      v-if="props.compromisso.data?.status === 'aprovado'"
      label="Data da Aprovação"
      :span="3"
    >
      {{ props.compromisso.data?.dataAprovacao ? dayjs(props.compromisso.data.dataAprovacao, 'DD/MM/YYYY').format('DD/MM/YYYY') : '' }}
    </a-descriptions-item>
  </a-descriptions>
</template>
